module.exports = __webpack_public_path__ + "static/media/bid-icon-pink.c9c391ce.svg";